import type { Event, Stacktrace } from "@sentry/types";

const stackTraceFromSolvvy = (stackTrace?: Stacktrace) => {
  if (!stackTrace) return false;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  return stackTrace.frames?.some(({ abs_path }) => abs_path?.includes("solvvy"));
};

const errorFromSolvvy = (event: Event): boolean => {
  return event?.exception?.values?.some(exception => stackTraceFromSolvvy(exception?.stacktrace));
};

const solvvyError = (event: Event): Event | null => {
  if (errorFromSolvvy(event)) {
    return null;
  }

  return event;
};

export { solvvyError };
